(function () {
  function deadline() {
    var next = new Date();
    next.setHours(23, 59, 59, 0);
    return next;
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function tick() {
    var diff = deadline() - Date.now();
    if (diff < 0) diff = 0;
    var days = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor(diff % 3600000 / 60000);
    var s = Math.floor(diff % 60000 / 1000);
    var pD = document.getElementById('promo-d');
    var pH = document.getElementById('promo-h');
    var pM = document.getElementById('promo-m');
    var pS = document.getElementById('promo-s');
    if (pD) pD.textContent = days;
    if (pH) pH.textContent = pad(h);
    if (pM) pM.textContent = pad(m);
    if (pS) pS.textContent = pad(s);
  }

  tick();
  setInterval(tick, 1000);
})();
